import type {
    ExecuteCommandResponseType,
    ExecuteCommandRequestType
} from "./type";
import {
    request
} from "../request";

const executeCommand = async (
    params: ExecuteCommandRequestType
): Promise<ExecuteCommandResponseType> => {
    return await request<ExecuteCommandResponseType>("/auth/executeCommand", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default executeCommand;
